
import { React } from "react";
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';

const Mapa = ({ destinos, elementosweb, config, lang }) => {
    let results = [];
    return (
        config.activa_mapa_web ?
            <div className="pt-4 pb-5 mt-4 mapa">

                <h2 className="text-center">{elementosweb.titulo_mapa ? elementosweb.titulo_mapa[lang] : ""}</h2>
                <p className="text-center">{elementosweb.subtitulo_mapa ? elementosweb.subtitulo_mapa[lang] : ""}</p>

                <MapContainer center={[51.505, -0.09]} zoom={config.zoom_mapa_web} scrollWheelZoom={false}>
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />

                    {destinos.forEach((undestino, index) => {
                        results = results.concat(
                            <Marker position={[undestino.latitud, undestino.longitud]} key={index}>
                                <Popup>
                                    <a href={"/apartamentos-" + undestino.laurl}>{undestino.elnombre}</a>
                                </Popup>
                            </Marker>
                        );
                    })}
                    {results}
                </MapContainer>
            </div>
            :
            <></>
    );
}

export default Mapa;
